/**
 CP:認購(CP)認售(P)
 */

export const cpOption = [
  { name: "全 部", value: "" },
  { name: "認 購", value: "c" },
  { name: "認 售", value: "p" },
];
/**
 *  p1:價內外程度1,
 *  p2:價內外程度2,
 */
export const priceOption = [
  { name: "不選", value: 9999 },
  { name: "價外25", value: -25 },
  { name: "價外20", value: -20 },
  { name: "價外15", value: -15 },
  { name: "價外10", value: -10 },
  { name: "價外5", value: -5 },
  { name: "價平", value: 0 },
  { name: "價內5", value: 5 },
  { name: "價內10", value: 10 },
  { name: "價內15", value: 15 },
  { name: "價內20", value: 20 },
  { name: "價內25", value: 25 },
];
/**
d1:剩餘天數1,
d2:剩餘天數2
*/
export const dayOption = [
  { name: "不選", value: 9999 },
  { name: "10日", value: 10 },
  { name: "30日", value: 30 },
  { name: "60日", value: 60 },
  { name: "90日", value: 90 },
  { name: "120日", value: 120 },
  { name: "150日", value: 150 },
  { name: "180日", value: 180 },
];
/**
  r1:行使比例1,
  r2:行使比例2
*/
export const percentOption = [
  { name: "不選", value: 9999 },
  { name: "0.01", value: 0.01 },
  { name: "0.1", value: 0.1 },
  { name: "0.2", value: 0.2 },
  { name: "0.5", value: 0.5 },
  { name: "1 ", value: 1 },
];

/**
qty1:成交量1,qty2:成交量2
*/
export const qtyOption = [
  { name: "不選", value: 999999 },
  { name: "100", value: 100 },
  { name: "500", value: 500 },
];
/**
 df1:價差比1,df2:價差比2,
*/

export const dfOption = [
  { name: "不選", value: 999999 },
  { name: "0.5%", value: 0.5 },
  { name: "1%", value: 1 },
  { name: "1.5%", value: 1.5 },
  { name: "2%", value: 2 },
];

/**
lv1:槓桿1,lv2:槓桿2
*/
export const lvOption = [
  { name: "不選", value: 999999 },
  { name: "1x", value: 1 },
  { name: "5x", value: 5 },
  { name: "10x", value: 10 },
  { name: "15x", value: 15 },
];
